var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appchart"},[(_vm.empty)?_c('el-empty',{staticClass:"charts",attrs:{"image-size":_vm.emptyImgSize}}):_c('div',{ref:_vm.id,staticClass:"charts",attrs:{"id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }